import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'; // Importación actualizada
import { PageEvent } from '@angular/material/paginator'; // Importación actualizada
import { DesitionBoxComponent } from 'src/app/modales/desition-box/desition-box.component';
import { EstudioSocioeconomicoService } from 'src/app/services/estudio-socioeconomico.service';
import { ParametrosService } from 'src/app/services/parametros.service';

const ELEMENT_DATA: any[] = [];

@Component({
    selector: 'app-estudio-socioeconomico',
    templateUrl: './estudio-socioeconomico.component.html',
    styleUrls: ['./estudio-socioeconomico.component.scss'],
    standalone: false
})
export class EstudioSocioeconomicoComponent implements OnInit {

  length = 0;
  pageSize = 50;
  pageSizeOptions: number[] = [50, 100, 150];

  // MatPaginator Output
  pageEvent: PageEvent;

  isLoading = false;
  displayedColumns: string[] = ['matricula', 'nombre', 'proceso', 'nivel', 'grado', 'estatus', 'becaActual', 'cuotaActual', 'becaAutorizada', 'descuento', 'cuotaAutorizada', 'autorizar'];
  dataSource = ELEMENT_DATA;

  formulario = new FormGroup({
    nombre: new FormControl("", []),
    nivel: new FormControl("", []),
    grado: new FormControl("", [])
  });

  niveles = [];
  grupos = [];

  constructor(
    private _parametrosService: ParametrosService,
    private _estudioSocioeconomicoService: EstudioSocioeconomicoService,
    public dialog: MatDialog // Cambiado aquí
  ) {
    this._parametrosService.findAll("niveles").subscribe(result => {
      this.niveles = result.datos.niveles;
    }, () => {
      console.info("");
    });
  }

  getGrados(id: number) {
    this._parametrosService.findAllDinamic("grados", id).subscribe(result => {
      this.grupos = result.datos.grados;
    });
  }

  ngOnInit(): void {
    this.buscador(0);
  }

  buscador(indice: number) {
    this._estudioSocioeconomicoService.find(this.formulario.controls["nombre"].value, this.formulario.controls["nivel"].value, this.formulario.controls["grado"].value, 0, this.pageSize).subscribe(result => {
      this.dataSource = result.datos.evaluaciones;
      console.log("this.dataSource: ", this.dataSource);
    });
  }

  save(evaluacion: any, ciclo: any, nivel: any, grado: any, alumno: any, desicion: any) {
    console.info(desicion);
  }

  print(info: any) {
    console.info(info);
  }

  actualizarbeca() {
    // Implementar lógica para actualizar la beca si es necesario
  }

  actualizar(campo: string, valor: string, ciclo: any, nivel: any, grado: any, alumno: any) {
    console.info(valor);
    const json = {
      campo: campo,
      valor: valor,
      ciclo: ciclo,
      nivel: nivel,
      grado: grado,
      alumno: alumno
    };

    document.getElementById(`spin_${campo}_${ciclo}_${nivel}_${grado}_${alumno}`).style.display = "block";
    
    this._estudioSocioeconomicoService.update(json).subscribe(result => {
      document.getElementById(`spin_${campo}_${ciclo}_${nivel}_${grado}_${alumno}`).style.display = "none";
      this.buscador(0);
    });
  }
  actualizarCuota(valor: string, element: any) {
    const { id_ciclo_fk, id_nivel_fk, id_grado_fk, id_alumno_fk, precio_unitario } = element;
    
    const nuevoValor = Number(valor);
    console.log(nuevoValor);
    if (isNaN(nuevoValor) || precio_unitario <= 0) {
        console.warn("Valor inválido");
        return;
    }

    const becaCalculada = 100 - (nuevoValor * 100 / precio_unitario);
    const json = {
        campo: 'beca',
        valor: becaCalculada,
        ciclo: id_ciclo_fk,
        nivel: id_nivel_fk,
        grado: id_grado_fk,
        alumno: id_alumno_fk
    };

    const spinner = document.getElementById(`spin_beca_${id_ciclo_fk}_${id_nivel_fk}_${id_grado_fk}_${id_alumno_fk}`);
    if (spinner) spinner.style.display = "block";

    this._estudioSocioeconomicoService.update(json).subscribe({
        next: (result) => {
            if (spinner) spinner.style.display = "none";
            this.buscador(0);
        },
        error: (err) => {
            console.error("Error al actualizar:", err);
            if (spinner) spinner.style.display = "none";
        }
    });
}

  autorizar(campo: string, valor: string, ciclo: any, nivel: any, grado: any, alumno: any): void {
    const dialogRef = this.dialog.open(DesitionBoxComponent, {
      data: { title: "Solicitud de confirmación", text: "¿Está seguro que desea autorizar este registro?", icon: "help_outline" }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed: ' + result);
      if (result) {
        this.isLoading = true;
        const json = {
          campo: campo,
          valor: valor,
          ciclo: ciclo,
          nivel: nivel,
          grado: grado,
          alumno: alumno
        };
        console.log("json a enviar: ", json);
        
        this._estudioSocioeconomicoService.update(json).subscribe(result => {
          this.isLoading = false;
          this.buscador(0);
        });
      }
    });
  }

  parseEstatus(id: number): string {
    return id === 0 ? "Sin iniciar" : "Concluido";
  }
}
